import { createRoute } from "../lib/createRoute";
import Pricing from "../pages/Pricing";

export const Route = createRoute(
  "/pricing",
  Pricing,
  "Flowstep Pricing: Plans for Every Team",
  "Compare Flowstep's pricing plans and find the best fit for your needs: from solo developers and designers to enterprise design workflows with custom benefits.",
);
